import PropTypes from 'prop-types';
import React from 'react';

import Image from '$partials/media/image';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleTicker = ({
    items,
    displayTitle,
    showDisplayTitle,
    parent
}) => {
    items = items?.items?.filter(item => !!item.logo) || [];
    if (!items.length) {
        return null;
    }

    // Duplicate messages to fill screen
    let displayedLogo = items;
    while (displayedLogo.length < 4) {
        displayedLogo = displayedLogo.concat(items);
    }

    // Duplicate messages to handle overflow repeats
    const duplicateCount = 4;
    let duplicatedLogos = [];
    for (let i = 0; i < duplicateCount; i++) {
        duplicatedLogos = duplicatedLogos.concat(displayedLogo);
    }

    const totalWidth = displayedLogo.reduce((partialSum, a) => partialSum + a.logo?.width, 0);
    const animationDuration = (totalWidth / 1440 * 100) * 0.5;

    return (
        <div className={`bg-white overflow-hidden relative ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'}`}>
            <div className='overflow-hidden'>
                <div className={'bg-white w-screen max-w-screen left-1/2 relative -translate-x-1/2 leading-[0]'}>
                    {showDisplayTitle && displayTitle && (
                        <div className='layout-container mb-40'>
                            <h3 className='w-full sm:w-8/12 md:w-6/12 px-10 sm:max-md:px-5 type-style-3'>{displayTitle}</h3>
                        </div>
                    )}
                    <Ticker
                        className='ticker'
                        items={duplicatedLogos}
                        style={{
                            animationDuration: `${animationDuration}s`
                        }}/>
                    <Ticker
                        className='ticker animation-direction-reverse mt-40'
                        items={[...duplicatedLogos].reverse()}
                        style={{
                            animationDuration: `${animationDuration}s`
                        }}/>
                </div>
            </div>
        </div>
    );
};


const Ticker = (props) => {
    return (
        <ul
            className={props.className}
            style={props.style}>
            {props.items?.map((item, i) => {
                if (!item) { return null; }
                const defaultAttributes = item.link ? {
                    'aria-label': `${item.title} case study`,
                    rel: 'noopener noreferrer',
                    target: '_blank',
                    href: item.link
                } : {};
                const ComponentTag = item.link ? 'a' : 'div';
                return (
                    <li
                        className={'inline-block mr-40 p-24 bg-sand rounded-xl'}
                        key={i}>
                        <ComponentTag
                            {...defaultAttributes}>
                            <div className='aspect-video w-[125px] pointer-events-none select-none'>
                                <Image
                                    {...item.logo}
                                    className='w-full h-full object-contain'
                                    containerClassName='w-full h-full relative'
                                    height='100%'
                                    loading=''
                                    loadWidth={285}
                                    width='100%'/>
                            </div>
                        </ComponentTag>

                    </li>
                );
            })}
        </ul>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    items: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    displayTitle: PropTypes.string,
    showDisplayTitle: PropTypes.bool,
    parent: PropTypes.string,
};

ModuleTicker.propTypes = propTypes;

Ticker.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    items: PropTypes.array,
};

export default ModuleTicker;
